/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szoa104aResponseVisitSearchResultDetailDto { 
    /**
     * 内部お客さま番号：数字
     */
    visitNo?: string;
    /**
     * お客さまカナ氏名：全角（カナ/数字/英字/スペース/記号）
     */
    visitKanaName?: string;
    /**
     * お客さま漢字氏名：全角
     */
    visitName?: string;
    /**
     * お客さま区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C300020」のユーザコードを設定
     */
    visitDiv?: string;
    /**
     * お客さま区分名称：全半角混在
     */
    visitDivAname?: string;
    /**
     * 月次締め回分：英数字<br>　コード変換マスターテーブル.画面項目ID「D001601」のユーザコードを設定
     */
    mnthlyClsingKaibun?: string;
    /**
     * 外部連携ID：英数字
     */
    extLinkId?: string;
    /**
     * お客さま電話番号１コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    telNoDiv1?: string;
    /**
     * お客さま電話番号１コード名称：全半角混在
     */
    telNoDiv1Aname?: string;
    /**
     * お客さま電話１番号：半角
     */
    telNo1?: string;
    /**
     * お客さま電話番号２コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    telNoDiv2?: string;
    /**
     * お客さま電話番号２コード名称：全半角混在
     */
    telNoDiv2Aname?: string;
    /**
     * お客さま電話２番号：半角
     */
    telNo2?: string;
    /**
     * お客さま電話番号３コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    telNoDiv3?: string;
    /**
     * お客さま電話番号３コード名称：全半角混在
     */
    telNoDiv3Aname?: string;
    /**
     * お客さま電話３番号：半角
     */
    telNo3?: string;
    /**
     * お客さまメールアドレス１テキスト：半角
     */
    maddr1?: string;
    /**
     * お客さまＦＡＸ１番号：半角
     */
    faxNo1?: string;
    /**
     * 住所コード：英数字
     */
    addrcd?: string;
    /**
     * 郵便番号：数字
     */
    postno?: string;
    /**
     * 都道府県名称：全角
     */
    pfcAname?: string;
    /**
     * 都道府県カナ名称：全角（カナ）
     */
    pfcKanaAname?: string;
    /**
     * 市区郡町村名称：全角
     */
    mptAname?: string;
    /**
     * 市区郡町村カナ名称：全角（カナ）
     */
    mptKanaAname?: string;
    /**
     * 町域名称：全角
     */
    twareaAname?: string;
    /**
     * 町域カナ名称：全角（カナ）
     */
    twareaKanaAname?: string;
    /**
     * 大字丁目名称：全角
     */
    oazaAname?: string;
    /**
     * 大字丁目カナ名称：全角（カナ）
     */
    oazaKanaAname?: string;
    /**
     * 番地：数字
     */
    banti?: string;
    /**
     * 番地区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008870」のユーザコードを設定
     */
    bantiDiv?: string;
    /**
     * 番地区分名称：全半角混在
     */
    bantiDivAname?: string;
    /**
     * 番地区分カナ名称：全半角混在
     */
    bantiDivKanaAname?: string;
    /**
     * 号：数字
     */
    gou?: string;
    /**
     * 号区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008880」のユーザコードを設定
     */
    gouDiv?: string;
    /**
     * 号区分名称：全半角混在
     */
    gouDivAname?: string;
    /**
     * 号区分カナ名称：全半角混在
     */
    gouDivKanaAname?: string;
    /**
     * 分筆号：英数字
     */
    bunptGou?: string;
    /**
     * 住宅・棟号漢字名：全角
     */
    supadrAname?: string;
    /**
     * 住宅・棟号カナ名：全角（カナ/数字/英字/スペース/記号）
     */
    supadrKananm?: string;
    /**
     * 屋号・業種・目標（漢字）：全角
     */
    yagouAname?: string;
    /**
     * 屋号・業種・目標（カナ）：全角（カナ/数字/英字/スペース/記号）
     */
    yagouKananm?: string;
    /**
     * 表示住所漢字
     */
    addrAnameF?: string;
    /**
     * 表示住所カナ
     */
    addrKanaAnameF?: string;
    /**
     * 契約リスト：数字
     */
    ctrList?: Array<string>;
    /**
     * 使用場所リスト：数字
     */
    empposList?: Array<string>;
}

